/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {

    // signin service
    loginUsingGoogle: (response) => {
        return axios.post(hostUrl + '/api/user/googleLogin', { access_token: response.accessToken })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add cors to apple login
    loginUsingApple: (response) => {
        return axios.post(hostUrl + '/api/user/appleLogin', response).then(res => {
              return res.data;
        })
        .catch(err => {
            console.log("AuthService loginUsingApple err", err);
            throw err.response.data;
        });
    },

    signinUsingApple: (response) => {
        return axios.post(hostUrl + '/api/user/appleSignin', response).then(res => {
              return res.data;
        })
        .catch(err => {
            console.log("AuthService signinUsingApple err", err);
            throw err.response.data;
        });
    },

    signin: (user) => {
        return axios.post(hostUrl + '/api/user/signin', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    markVisited: (page) => {
        return axios.put(hostUrl + '/api/user/markVisited', { page: page })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getNotifications: () => {
        return axios.get(hostUrl + '/api/user/notifications')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addNotification: (userEmail, page, type, title, description) => {
        return axios.post(hostUrl + '/api/user/notification', { userEmail: userEmail, page: page, type: type, title: title, description: description })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    markNotificationAsRead: (page, notificationId) => {
        return axios.put(hostUrl + '/api/user/markNotificationAsRead', { page: page, notificationId: notificationId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    sendVerifyMail: email => {
        return axios.post(hostUrl + '/api/client/sendVerifyMail', { email })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    verifyUser: user => {
        return axios.post(hostUrl + '/api/user/verifyuser', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updatePassword: (user) => {
        return axios.put(hostUrl + '/api/user/updatepassword', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    forgotPassword: email => {
        return axios.post(hostUrl + '/api/user/forgotpassword', { email })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    resetPassword: user => {
        return axios.post(hostUrl + '/api/user/resetpassword', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // register user service
    registerUser: user => {
        return axios.post(hostUrl + '/api/user/signup', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // register provider service
    registerProvider: user => {
        return fetch(hostUrl + '/api/admin/registerProvider', {
            method: "POST",
            body: JSON.stringify(user),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.status !== 401) {
                return res.json().then(data => data);
            } else {
                return { isAuthenticated: false, user: { username: "", email: "", profileImage: "", selectedRole: '', roles: [] } }
            }
        })
    },


    // register admin service
    registerAdmin: user => {
        return fetch(hostUrl + '/api/admin/registerAdmin', {
            method: "POST",
            body: JSON.stringify(user),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.status !== 401) {
                return res.json().then(data => data);
            } else {
                return { isAuthenticated: false, user: { username: "", email: "", profileImage: "", selectedRole: '', roles: [] } }
            }
        })
    },


    // logout service
    logout: () => {
        return axios.get(hostUrl + '/api/user/logout')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    //  update timezone
    updateTimezone: (user) => {
        return axios.post(hostUrl + '/api/user/updatetimezone', {user})
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // isAuthenticated service - persist authentication
    isAuthenticated: () => {
        return axios.get(hostUrl + '/api/user/authenticated', {
            headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' }
        })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err;
            });

        // return axios.get('/user/authenticated')
        // .then(res => {
        //     console.log("res",res);
        //     return res.data;
        // })
        // .catch(err => {
        //     console.log("err",err);
        //     throw err;
        // });
    }

}